/**
 * KnowledgeTheme — design-tokens a Skin injects into the KnowledgeView
 * to influence pin colors, animation timing, 3D-viewer parameters, etc.
 *
 * Tschepp's tscheppa-ar-web ships forest-green pins with white borders;
 * Wanderlaut defaults to nüchtern slate-blue. Both consume the same
 * KnowledgeTheme shape.
 *
 * STATUS: Skeleton + DEFAULT_KNOWLEDGE_THEME constants — Tschepp
 * locks the shape, then we wire it through the renderers.
 */
/** Nüchterne Defaults für Wanderlaut. Tscheppa overrides nearly all of
 *  these; Wanderlaut consumers ship as-is unless they bring their own
 *  brand identity. */
export const DEFAULT_KNOWLEDGE_THEME = {
    pinColor: {
        idle: 'rgba(255, 255, 255, 0.9)',
        active: 'rgba(58, 134, 255, 0.95)',
        hovered: 'rgba(196, 169, 106, 0.95)',
    },
    pinTextColor: {
        idle: '#1a2e1a',
        active: '#ffffff',
    },
    pinBorderColor: {
        idle: 'rgba(0, 0, 0, 0.25)',
        active: 'rgba(255, 255, 255, 0.8)',
        hovered: 'rgba(255, 255, 255, 0.6)',
    },
    pinSize: { idle: 28, active: 36 },
    pinShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    audioPlayerStyle: 'floating',
    annotationPanelPosition: 'right-of-pin',
    loadingStateColor: '#3a86ff',
    errorStateColor: '#f7768e',
    spinnerStyle: 'pulse',
    pinTransitionMs: 200,
    panelTransitionMs: 300,
    threeDViewer: {
        background: null,
        autoRotateSpeed: 0.6,
        pinOutwardExtrude: 0.07,
        pinDepthTest: true,
    },
};
//# sourceMappingURL=theme.js.map